import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor(private http: HttpClient) { }

  uploadVideo(file: File): Observable<HttpEvent<any>> {
    const uploadUrl: string = `${environment.apiUrl}/upload`;
    const formData: FormData = new FormData();
    formData.append('video', file);
    return this.http.post(uploadUrl, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  sendData(
    id: number,
    title: string,
    context: string,
    duration: number,
    langFrom: number,
    langTo: number,
  ): Observable<any> {
    const url: string = `${environment.apiUrl}/jobs/${id}`;
    return this.http.post(url, {
      title: title,
      context: context,
      duration: duration, // duration en seconde.
      lang_source: langFrom,
      lang_cible: langTo,
    });
  }

  updateTask(taskId: number): Observable<any> {
    const url: string = `${environment.apiUrl}/script/tasks/${taskId}/update`;
    return this.http.patch(url, {
      status: 'COMPLETED',
      pogress: 100,
      message: 'upload terminée',
    });
  }
}
